export default "__VITE_ASSET__D6q62AdS__"